export const TAGS_TYPES = {
	TEXT: 'TEXT',
	ICON: 'ICON',
	HIDDEN: 'HIDDEN'
};

export const isNextText = (element) => element?.type === TAGS_TYPES.TEXT;
